import React, { Component } from "react";
import styled, { css } from "styled-components";
import { Link } from "./common/Link";

import Spinner from "./Spinners/SimpleSpinner";

import tradingBg from "../images/trading-button-bg.png";

const LinkView = styled(Link)`
  display: inline-block;
  vertical-align: middle;
  width: auto;
  padding: 0 14px;
  box-sizing: border-box;
  border-radius: 8px;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  line-height: 39px;
  text-decoration: none;
  white-space: nowrap;
  color: #fff;
  border: none;
  perspective: 1000px;

  :hover,
  :focus,
  :active {
    text-decoration: none;
    color: #fff;
  }

  background-color: #61ad12;
  background: linear-gradient(to bottom, #68c604 0%, #61ad12 100%);
  :hover {
    background-color: #68c604;
    background: linear-gradient(to bottom, #61ad12 0%, #68c604 100%);
  }

  ${props =>
    props.wide &&
    css`
      display: inline-block;
      width: 100%;
      text-align: center;
      padding-left: 20px;
      padding-right: 20px;
    `}

  ${props =>
    props.mobile &&
    css`
      min-width: 220px;
      max-width: 290px;
      padding: 12px 15px;
      min-height: 51px;
      line-height: 1;
      font-size: 24px;
      text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.22);
      box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.3),
        inset 0px -3px 0px 0px rgba(255, 255, 255, 0.1);
      white-space: normal;
      @media (max-width: 480px) {
        line-height: 1;
        font-size: 22px;
        padding: 13px 15px;
        margin: 0 auto 0;
      }
    `}

  ${props =>
    props.big &&
    css`
      min-width: 0px;
      width: 100%;
      height: 68px;
      min-height: 68px;
      line-height: 44px;
      font-weight: 700;
      font-size: 27px;
      @media (max-width: 959px) {
        line-height: 1;
        font-size: 22px;
        height: 48px;
        min-height: 48px;
      }
    `}

  ${props =>
    props.bigfckinbutton &&
    css`
      margin: 0px;
      padding: 0 18px;
      line-height: 47px;
      border-radius: 8px;
      box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.3),
        inset 0px -3px 0px 0px rgba(255, 255, 255, 0.1);
    `}

  ${props =>
    props.type === "yellow" &&
    css`
      margin-right: 0px;
      background-color: ${props => props.theme.accent};
      background: linear-gradient(
        to bottom,
        ${props => props.theme.accent} 0%,
        #fd9500 100%
      );
      @media (max-width: 480px) {
        margin-right: 0px;
      }
      :hover {
        background-color: #fd9500;
        background: linear-gradient(
          to bottom,
          #fd9500 0%,
          ${props => props.theme.accent} 100%
        );
      }
    `}

  ${props =>
    props.type === "violet" &&
    css`
      background-color: #706281;
      background: linear-gradient(to bottom, #877c95 0%, #706281 100%);
      :hover {
        background-color: #877c95;
        background: linear-gradient(to bottom, #706281 0%, #877c95 100%);
      }
    `}

  ${props =>
    props.longText &&
    css`
      @media (max-width: 479px) {
        padding-left: 5px;
        padding-right: 5px;
        font-size: ${({ theme }) =>
          theme.locale === "ar" ? theme.minFontSize : "14px"};
      }

      @media (max-width: 359px) {
        font-size: ${({ theme }) =>
          theme.locale === "ar" ? theme.minFontSize : "12px"};
      }
    `}
`;

const Image = styled.img`
  margin-right: 7px;
  position: relative;
  top: 3px;
  width: 20px;
  height: auto;
  @media (max-width: 480px) {
    margin-right: 6px;
    top: 1px;
    width: 17px;
  }
`;

const Text = styled.span`
  display: inline-block;

  ${({ theme }) =>
    theme.locale !== "ar" &&
    css`
      :first-letter {
        text-transform: uppercase;
      }
    `};
`;

class LinkButton extends Component {
  render() {
    const {
      text,
      type,
      to,
      wide,
      big,
      mobile,
      onClick,
      showSpinner,
      longText,
      bigfckinbutton,
      children
    } = this.props;

    return (
      <LinkView
        to={to}
        onClick={onClick}
        wide={wide}
        mobile={mobile}
        big={big}
        type={type}
        longText={longText}
        bigfckinbutton={bigfckinbutton}
      >
        {type === "yellow" && <Image src={tradingBg} alt={tradingBg} />}

        {showSpinner && <Spinner />}
        <Text>{text || children}</Text>
      </LinkView>
    );
  }
}

export default LinkButton;



// WEBPACK FOOTER //
// ./src/components/LinkButton.js